import { Spotlight } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useIntl } from 'react-intl-next';

import { messages } from './messages';

export const MoreActionsSpotlight = ({ onFinish }: { onFinish: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onFinish,
					text: formatMessage(messages.okButton),
				},
			]}
			target="project-issue-navigator.ui.page-actions.meatball-menu"
			key="project-issue-navigator.ui.page-actions.meatball-menu"
			targetRadius={3}
			dialogWidth={285}
			targetBgColor={token('elevation.surface')}
			// eslint-disable-next-line formatjs/no-literal-string-in-jsx
			actionsBeforeElement={<>2/2</>}
			testId="more-actions-spotlight"
			dialogPlacement="left top"
		>
			{formatMessage(messages.moreActionsSpotlightMessage)}
		</Spotlight>
	);
};
